export class ApiError extends Error {
    public code: number;
    public override message: string;
    /**
     * The machine-readable half of the API's error envelope (`errors[0].reason`), where one was
     * sent. Callers branch on it to tell two refusals with the same status apart — a declined
     * card from a stale quote, say — and it is optional everywhere, so a response without one
     * behaves exactly as before.
     */
    public reason: string | null;

    constructor(message: string, code: number = 500, reason: string | null = null) {
        super(message);
        this.name = 'ApiError';
        this.code = code;
        this.message = message;
        this.reason = reason;
        
        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ApiError);
        }
    }

    static fromFetchError(error: any): ApiError {
        // An ApiError has already been given its status and reason by the caller that threw it —
        // re-deriving them here found neither (an ApiError carries `code`, not `status`) and
        // flattened every service refusal to a 500, which is what the 402/409/422 branches in the
        // pages were reading. Pass it straight through.
        if (error instanceof ApiError) return error;
        const code = error.response?.status || error.status || error.statusCode || 500;
        const message = error.data?.message || error.message || 'An error occurred';
        return new ApiError(message, code);
    }
} 